import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'components/atoms/Button';
import OnboardingStepWrapper from '../../components/OnboardingStepWrapper';
// todo: solve deps cycle
import StepsProgressSummary from '../../components/StepsProgressSummary';
import type { ActivationStepProps } from '../types';

/**
 * Initial activation step showing checklist of completed onboarding steps
 * This is the entry point for the post-account activation flow
 *
 * Now uses dynamic ActivationProgressSummary component to show all main steps
 * with their completion status based on current flow position
 */
const InitActivationStep: FC<ActivationStepProps> = ({
  onContinue,
  // Wrapper props (automatically injected)
  progressSegments,
  onProgressSegmentClick,
  title,
  subtitle,
  icon,
  showProgressBar,
  isUpdatingStep,
}) => {
  const { t } = useTranslation();

  return (
    <OnboardingStepWrapper
      showProgressBar={showProgressBar}
      progressSegments={progressSegments}
      onProgressSegmentClick={onProgressSegmentClick}
      icon={icon}
      title={title}
      subtitle={subtitle}
    >
      <div className="my-5">
        {/* Dynamic summary showing all main steps (completed pre-account + current post-account) */}
        <StepsProgressSummary currentSubstepId="init_activation" mode="all" />
      </div>

      <Button
        onClick={onContinue}
        className="w-full mt-3"
        color="bank"
        disabled={isUpdatingStep}
      >
        {t('continue')}
      </Button>
    </OnboardingStepWrapper>
  );
};

export default InitActivationStep;
